module.exports = __webpack_public_path__ + "img/android_google.a73c536e.png";